class CustomerAuth extends HTMLElement {
    constructor() {
        super();

        this.auth = this;

        this.bindEvents();
        this.handleLogoutFlag();   // 🔥 NEW
        this.showAuthToast();      // 🔥 LOGIN + LOGOUT TOAST
    }

    bindEvents() {
        document.querySelectorAll('[data-open-auth-popup]').forEach((openPopup) =>
            openPopup.addEventListener('click', this.setOpenPopup.bind(this))
        );

        document.querySelectorAll('[data-close-auth-popup]').forEach((closePopup) =>
            closePopup.addEventListener('click', this.setClosePopup.bind(this))
        );

        document.querySelectorAll('[data-open-auth-sidebar]').forEach((openSidebar) =>
            openSidebar.addEventListener('click', this.setOpenSidebar.bind(this))
        );

        document.querySelectorAll('[data-close-auth-sidebar]').forEach((closeSidebar) =>
            closeSidebar.addEventListener('click', this.setCloseSidebar.bind(this))
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    /* -------- LOGOUT FLAG (NEW) -------- */
    handleLogoutFlag() {
        document.querySelectorAll('[data-auth-logout]').forEach(btn => {
            btn.addEventListener('click', () => {
                sessionStorage.setItem('shopifyLogoutSuccess', 'true');
            });
        });
    }

    /* -------- LOGIN + LOGOUT TOAST -------- */
 showAuthToast() {
    const login = sessionStorage.getItem('shopifyLoginSuccess');
    const logout = sessionStorage.getItem('shopifyLogoutSuccess');
    const register = sessionStorage.getItem('shopifyRegisterSuccess');

    if (!login && !logout && !register) return;

    const toast = document.getElementById('login-toast');
    if (!toast) return;

    let message = '';

    // ✅ PRIORITY FIX (IMPORTANT)
    if (register) {
        message = '🎉 Account created successfully';

        // Shopify auto-login fix
        sessionStorage.removeItem('shopifyLoginSuccess');

    } else if (logout) {
        message = '👋 Successfully logged out';

    } else if (login) {
        message = '✅ Successfully logged in';
    }

    toast.textContent = message;

    document.body.appendChild(toast);
    toast.hidden = false;

    requestAnimationFrame(() => {
        toast.classList.add('show');
    });

    setTimeout(() => {
        toast.classList.remove('show');
        toast.hidden = true;
    }, 3000);

    // ✅ CLEANUP
    sessionStorage.removeItem('shopifyLoginSuccess');
    sessionStorage.removeItem('shopifyLogoutSuccess');
    sessionStorage.removeItem('shopifyRegisterSuccess');
}
    /* ----------------------------------- */

    setOpenPopup(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({ scrollTop: 0 }, 700);
        } else {
            document.body.classList.add('auth-popup-show');
        }
    }

    setClosePopup(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('auth-popup-show');
    }

    setOpenSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({ scrollTop: 0 }, 700);
        } else {
            document.body.classList.add('auth-sidebar-show');
        }
    }

    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('auth-sidebar-show');
    }
    
    onBodyClickEvent(event){
        if(document.body.classList.contains('auth-popup-show')){
            if (!this.contains(event.target) && !event.target.closest('[data-open-auth-popup]')){
                this.setClosePopup(event);
            }
        }
        
        if(document.body.classList.contains('auth-sidebar-show')){
            if (!this.contains(event.target) &&
                !event.target.closest('[data-open-auth-sidebar]') &&
                !event.target.closest('[data-auth-sidebar]')){
                event.stopImmediatePropagation();
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('customer-auth', CustomerAuth);
